import React, { useState } from 'react';

import axios from 'axios';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Invoice from 'components/Coupon/Invoice';
import Estimate from 'components/Coupon/Estimate';

export default function FormMng() {
  const [isTextField, setIsTextField] = useState(false);
  const [invoiceInfo, setInvoiceInfo] = useState({});
  const [openInvoice, setOpenInvoice] = useState(true);
  const [openEstimate, setOpenEstimate] = useState(false);

  const handleClickInvoice = (e) => {
    setOpenInvoice(true);
    setOpenEstimate(false);
  };

  const handleClickEstimate = (e) => {
    setOpenEstimate(true);
    setOpenInvoice(false);
  };

  const getInvoiceInfo = async (e) => {
    const result = window.prompt('주문번호를 입력하세요.');
    if (result) {
      const response = await axios.get(`/api/form/invoice`, { params: { orderNo: result } });
      if (response) {
        setInvoiceInfo(response.data);
      }
    }
  };

  const createInvoice = async (e) => {
    const page = document.getElementById('page');

    const canvas = await html2canvas(page, { scale: 4 });
    const imageFile = canvas.toDataURL('image/jpeg');
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const widthRatio = pageWidth / canvas.width;
    const customHeight = canvas.height * widthRatio;
    doc.addImage(imageFile, 'png', 0, 0, pageWidth, customHeight);

    const docBlob = doc.output('blob');
    const docFile = new File([docBlob], 'name.pdf');

    let frm = new FormData();
    frm.append('orderNo', invoiceInfo?.orderNo);
    frm.append('pdfFile', docFile);
    Object.keys((key) => {
      frm.append(key, invoiceInfo[key]);
    });

    const response = await axios.post(`/api/form/invoice`, frm, { headers: { 'Content-Type': 'multipart/form-data' } });
    if (response) {
      // setInvoiceInfo(response.data);
    }
  };

  const converToPdf = async () => {
    const page = document.getElementById('page');

    //1.html을 들고와서 canvas화
    const canvas = await html2canvas(page, { scale: 4 });
    //2.이미지화
    const imageFile = canvas.toDataURL('image/jpeg');
    //3.pdf준비
    const doc = new jsPDF('p', 'mm', 'a4');
    //pdf 가로 세로 사이즈
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    //이미지의 길이와 pdf의 가로길이가 다르므로 이미지 길이를 기준으로 비율을 구함
    const widthRatio = pageWidth / canvas.width;
    //비율에 따른 이미지 높이
    const customHeight = canvas.height * widthRatio;
    //pdf에 1장에 대한 이미지 추가
    doc.addImage(imageFile, 'png', 0, 0, pageWidth, customHeight);
    //doc.addImage(imgData, 'PNG', margin, position, imgWidth, imgHeight);
    //감소하면서 남은 길이 변수
    // let heightLeft = customHeight;
    //증가하면서 이미지 자를 위치 변수
    // let heightAdd = -pageHeight;

    // 한 페이지 이상일 경우
    // while (heightLeft >= pageHeight) {
    //   //pdf페이지 추가
    //   doc.addPage();
    //   //남은 이미지를 추가
    //   doc.addImage(imageFile, 'png', 0, heightAdd, pageWidth, customHeight);
    //   //남은길이
    //   heightLeft -= pageHeight;
    //   //남은높이
    //   heightAdd -= pageHeight;
    // }
    //문서저장
    doc.save('filename' + new Date().getTime() + '.pdf');
  };

  return (
    <>
      <Box sx={{ m: 2 }}>
        <Button variant="contained" onClick={handleClickInvoice}>
          Invoice
        </Button>
        <Button variant="contained" onClick={handleClickEstimate} sx={{ ml: 1 }}>
          견적서
        </Button>
      </Box>
      <Box sx={{ m: 2 }}>
        <Button variant={isTextField ? 'contained' : 'outlined'} onClick={(e) => setIsTextField(!isTextField)}>
          입력창활성화
        </Button>
        {openInvoice && (
          <>
            <Button onClick={getInvoiceInfo}>주문정보 불러오기</Button>
            <Button onClick={converToPdf}>Invoice 다운로드</Button>
            <Button onClick={createInvoice}>Invoice 서버에 재생성 (이전파일 덮어쓰기)</Button>
          </>
        )}
        {openEstimate && (
          <>
            <Button onClick={converToPdf}>견적서 다운로드</Button>
          </>
        )}
      </Box>
      {openInvoice && <Invoice isTextField={isTextField} invoiceInfo={invoiceInfo} />}
      {openEstimate && <Estimate isTextField={isTextField} invoiceInfo={invoiceInfo} />}
    </>
  );
}
